import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/tack-analysis-reel.mp4")